/**
 * KADRAJ DURUMU
 * ===========================================================================
 * Kullanıcı çerçevede mi, değilse neden değil. Tek bir "görünüyor/görünmüyor"
 * bayrağı yetmiyor: TV'de gösterilecek uyarı metni sebebe göre değişiyor ve
 * "biraz geri çekil" ile "kameranın önüne geç" bambaşka davranışlar.
 *
 * ⚠️ Bu klasörde göreli importlar `.ts` uzantılı olmalı, `@/` kullanılmaz.
 */

export const FRAME_STATES = [
  /** Her şey yolunda, skorlama çalışabilir. */
  'in_frame',
  /** Kimse görünmüyor. */
  'no_person',
  /** Çok yakın: hem baş hem ayaklar kesiliyor. */
  'too_close',
  /** Gövde var ama kritik eklemlerden biri görünmüyor. */
  'partial',
  /** Çok uzak: iskelet küçüldükçe gürültü skorlamayı bozuyor. */
  'too_far',
  /** Kadrajın kenarına kaymış. */
  'off_center',
] as const;

export type FrameState = (typeof FRAME_STATES)[number];

/** TV'de gösterilecek kısa yönlendirme. */
export const FRAME_STATE_HINT: Record<FrameState, string> = {
  in_frame: '',
  no_person: 'Kameranın önüne geç',
  too_close: 'Biraz geri çekil',
  partial: 'Tüm vücudun görünsün',
  too_far: 'Biraz yaklaş',
  off_center: 'Ortala',
};

/** Skorlama yalnızca kadrajdayken anlamlı. */
export const isScorable = (state: FrameState): boolean => {
  'worklet';
  return state === 'in_frame';
};
